<mat-expansion-panel class="syn-expansion-panel" *ngIf="expansion">
    <mat-expansion-panel-header>
        <mat-panel-title>{{headerText}}</mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-template>
</mat-expansion-panel>

<mat-card appearance="outlined" class="syn-card" [class]="{ 'syn-box-fill__height': fillHeight}" *ngIf="!expansion">
    <mat-card-header>
        <mat-card-title>{{headerText}}</mat-card-title>
        <mat-card-subtitle *ngIf="headerSubTitle">{{headerSubTitle}}</mat-card-subtitle>
    </mat-card-header>
    <ng-container *ngTemplateOutlet="content"></ng-container>
</mat-card>

<ng-template #content>
    <mat-card-content [style.maxHeight]="maxContentHeight"
                      [class.syn-overflow]="maxContentHeight"
                      [class.noPadding]=" noPadding">
    <ng-content></ng-content>
    </mat-card-content>
</ng-template>
